import React, {Component} from 'react';
import Button from './Button';
import {Link} from 'react-router-dom'
class Box extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {

    const {
      containtText,
      title,
      buttonText,
      buttonTextClassBox,
      buttonClass,
      routeLink,
      setActive
    } = this.props;

    return (<div className="box">
      <h3>
        {title}
      </h3>
      <p>
        {containtText}
      </p>
      <Link to={{
          pathname: routeLink,
          search: this.props.location.search,
          state: {
            active: setActive,
          }
        }} style={{textDecoration: 'none'}}>
        <Button buttonText={buttonText} buttonTextclassName={buttonTextClassBox} buttonclassName={buttonClass}/>
      </Link>
    </ div>);
  }
}

export default Box;
